import { Navigate, useSearchParams } from 'react-router-dom';

import { NotificacoesAnaliticasPage } from '@/modulos/operacao/analises/NotificacoesAnaliticasPage';

/**
 * `/sme/notificacoes` — central de notificações, na casca do Portal SME.
 *
 * O protótipo não tem tela de notificação própria da SME: `SmeNotificacoesWrapper.tsx`
 * monta a mesma lista de `/notificacoes`, que aqui é `NotificacoesAnaliticasPage`
 * (`/operacao/notificacoes`). Reusar a tela, e não copiá-la, é o que mantém as
 * duas iguais — mesmo padrão das outras telas que o protótipo registra nas duas
 * cascas (`App.tsx`, `TELAS_PRONTAS`). Desde 2026-10-03 ela lê a caixa real de
 * quem está logado (`bff/v1/notificacoes`): aqui, os avisos endereçados à
 * pessoa da SME ou da DRE.
 *
 * O que o wrapper do protótipo acrescenta vem junto: a antiga aba "Mensagens
 * com credenciados" virou tela própria, e o endereço antigo (`?tab=mensagens`)
 * continua levando para ela.
 */
export function NotificacoesSmePage() {
  const [parametros] = useSearchParams();
  if (parametros.get('tab') === 'mensagens') {
    return <Navigate to="/sme/mensagens" replace />;
  }
  return <NotificacoesAnaliticasPage />;
}
